import { DateTime } from "luxon";
import React from "react";
import s from "./PageTitle.module.scss";
import { useDateFormat } from "../../hooks/useDateFormat";

export default function PageTitle({ children }: { children: React.ReactNode; }): JSX.Element {
  return <h1 className={s.pageTitle}>{children}<span>{DateTime.local().toFormat(useDateFormat("date"))}</span></h1>;
}